import { Button, Modal } from 'react-bootstrap';

type ProductPlanLimitModalProps = {
  show: boolean;
  onHide: () => void;
  onUpgrade: () => void;
};

export default function ProductPlanLimitModal({
  show,
  onHide,
  onUpgrade,
}: ProductPlanLimitModalProps) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Product limit reached</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        You have reached a limit of available products on your plan. To be able
        to add more products, please upgrade your plan.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={onUpgrade}>
          Upgrade Plan
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
